import {activityDayBounds,dateKey,shiftDate} from './activity-model.js';

// UI-only fixtures requested for the named test tracker; never LocalEvent objects.
export function historyDisplayFixtures(name,date,now=Date.now()) {
  const today=dateKey(now);
  if(name!=='Test Tracker'||date>today||date<shiftDate(today,-6))return [];
  const start=Date.parse(activityDayBounds(date).startAt);
  return [2,5,8,10].map((hour,i)=>({key:`local-display-${date}-${i}`,time:new Date(start+hour*3600000).toISOString(),title:['Forbindelse genoprettet','Opladning startet','Opladning afsluttet','Armbånd tilsluttet'][i]})).filter(row=>Date.parse(row.time)<=now);
}
